import React from 'react';
import { Container, Box } from '@mui/material';

const PageWrapper = ({ children, fullWidth }) => (
  <Container maxWidth={fullWidth ? false : "lg"}>
    <Box sx={{ my: 4 }}>{children}</Box>
  </Container>
);

export default PageWrapper;